var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100vh","padding-top":"50px","padding-bottom":"50px","overflow-y":"auto"}},[_c('Header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }